<template>
  <el-form ref="form" label-width="120px" class="user-dialog">
    <el-form-item label="Username" class="username">{{user.name}}</el-form-item>
    <el-form-item label="Name" class="name">{{user.fullName}}</el-form-item>
    <el-form-item label="Role">
      <el-select v-model="selectedRole" value-key="attributes.name" placeholder="Select a user"> 
        <el-option v-for="role in roles" :key="role.id" :label="role.attributes.displayName" :value="role"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="buttons">
      <el-button @click="cancel">Cancel</el-button>
      <el-button type="primary" @click="save">Save</el-button>
    </el-form-item>
  </el-form>
</template>

<script>

export default {

  props: {
    user: Object,
    close: Function
  },
  data () {
    let lpRoles = this.$store.getters['roles/all']
    // let fluxRoles = this.$store.getters{'flux-roles/all']
    let roles = lpRoles
    return {
      roles: roles,
      selectedRole: null
    }
  },
  computed: {

  },
  mounted () {
  },
  created () {
    document.addEventListener('keypress', this.keypress)
  },
  destroyed () {
    document.removeEventListener('keypress', this.keypress)
  },
  methods: {
    keypress (e) {
      e.keyCode === 13 && this.save()
    },
    cancel () {
      this.close()
    },
    save () {
      this.close()
    }
  }
}
</script>

<style lang='scss' scoped>
  @import '../styles/common.scss';
  .buttons {
    float:right;
  }
  .el-form {
    margin-bottom:60px;
  }
</style>

<style lang='scss'>
  .user-dialog {

    .username {
      margin-top: -30px;
      margin-bottom: 0px;
    }
    .name {
      margin-bottom: 10px;
    }
    .username, .name {

      label, div {
        line-height: 20px;
      }
    }
  }
</style>